import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { ArrowsLeftRight } from '@phosphor-icons/react';

export function ReconcilePanel({ reconcileData, reconcileLoading, showReconcile, onPreview, onApply, onClose }) {
  return (
    <>
      <div className="mb-6">
        <Button
          onClick={onPreview}
          disabled={reconcileLoading}
          variant="outline"
          className="border-[#333333] bg-[#1A1A1A] text-[#999999] hover:text-white hover:bg-[#333333] rounded-lg"
          data-testid="reconcile-preview-button"
        >
          <ArrowsLeftRight className="w-4 h-4 mr-2" />
          {reconcileLoading ? 'Calculating...' : 'Reconcile Balances'}
        </Button>
      </div>

      {showReconcile && reconcileData && (
        <Card className="bg-[#1A1A1A] border-[#222222] rounded-lg mb-6" data-testid="reconcile-panel">
          <CardHeader className="border-b border-[#222222] py-3 px-4">
            <div className="flex items-center justify-between">
              <CardTitle className="text-sm text-white font-semibold">
                Balance Reconciliation
                {reconcileData.accounts_needing_adjustment > 0 && (
                  <span className="ml-2 text-xs bg-yellow-500/10 text-yellow-400 px-2 py-0.5 rounded-full">
                    {reconcileData.accounts_needing_adjustment} need adjustment
                  </span>
                )}
              </CardTitle>
              <div className="flex gap-2">
                {reconcileData.accounts_needing_adjustment > 0 && (
                  <Button
                    onClick={onApply}
                    disabled={reconcileLoading}
                    size="sm"
                    className="bg-[#22C55E] hover:bg-[#1EA34B] text-black font-bold rounded-lg text-xs"
                    data-testid="reconcile-apply-button"
                  >
                    {reconcileLoading ? 'Applying...' : 'Apply All Corrections'}
                  </Button>
                )}
                <Button onClick={onClose} variant="ghost" size="sm" className="text-[#999999] hover:text-white">
                  Close
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardContent className="p-0">
            {reconcileData.accounts.length === 0 ? (
              <div className="p-8 text-center text-[#666666]">No accounts with activity found</div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="text-[10px] uppercase tracking-wider text-[#666666] border-b border-[#222222]">
                      <th className="text-left px-4 py-2">User</th>
                      <th className="text-right px-2 py-2">Deposits</th>
                      <th className="text-right px-2 py-2">Received</th>
                      <th className="text-right px-2 py-2">Sent</th>
                      <th className="text-right px-2 py-2">Fees</th>
                      <th className="text-right px-2 py-2">Withdrawn</th>
                      <th className="text-right px-2 py-2">Correct</th>
                      <th className="text-right px-2 py-2">Current</th>
                      <th className="text-right px-4 py-2">Diff</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reconcileData.accounts.map((a) => (
                      <tr key={a.user_id} className={`border-b border-[#1A1A1A] ${a.needs_adjustment ? 'bg-yellow-500/5' : ''}`} data-testid={`reconcile-row-${a.user_id}`}>
                        <td className="px-4 py-2">
                          <p className="text-white text-xs font-medium truncate max-w-[140px]">{a.name}</p>
                          <p className="text-[#666666] text-[10px] truncate max-w-[140px]">{a.email}</p>
                        </td>
                        <td className="text-right px-2 py-2 text-[#22C55E] text-xs">${a.deposits.toFixed(2)}</td>
                        <td className="text-right px-2 py-2 text-[#22C55E] text-xs">${a.received.toFixed(2)}</td>
                        <td className="text-right px-2 py-2 text-red-400 text-xs">${a.sent.toFixed(2)}</td>
                        <td className="text-right px-2 py-2 text-red-400 text-xs">${a.fees_paid.toFixed(2)}</td>
                        <td className="text-right px-2 py-2 text-red-400 text-xs">${a.withdrawn.toFixed(2)}</td>
                        <td className="text-right px-2 py-2 text-white font-semibold text-xs">${a.correct_balance.toFixed(2)}</td>
                        <td className="text-right px-2 py-2 text-[#999999] text-xs">${a.current_balance.toFixed(2)}</td>
                        <td className={`text-right px-4 py-2 text-xs font-bold ${a.difference > 0 ? 'text-[#22C55E]' : a.difference < 0 ? 'text-red-400' : 'text-[#666666]'}`}>
                          {a.difference > 0 ? '+' : ''}{a.difference.toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardContent>
        </Card>
      )}
    </>
  );
}
